<template>
    <div class="index">
        <div class="container" v-if="this.$route.params.type">
            <div class="survey-header">
                <div class="survey-header-inner">
                    <p class="pre-heading" v-html="content.pre_title"></p>
                    <h1 class="mw-630" v-html="content.title"></h1>
                </div>
                <p class="survey-count">
                    <span class="survey-count-current" v-html="content.currentSurveyStep"></span><span class="survey-count-total" v-html="'/' + content.surveys.length"></span>
                </p>
            </div>
            <div class="main-content-inner">
                <div class="loading-indicator" v-if="content.isLoading">
                    <img src="../assets/loader.svg" alt="Loader">
                </div>
                <form class="form survey-form survey" action="#" v-if="!content.sent" @submit.prevent="sendForm" @mousewheel="scrollHandler($event)">
                    <div v-for="(survey, surveyIndex) in content.surveys">
                        <div :class="'survey-item d-flex align-items-center justify-content-center flex-column ' +  (surveyIndex == 0 && index == 0 ? 'active' : '')" v-for="(item, index) in survey.steps" @click="setActiveSurveyItem(surveyIndex, index)" :data-survey-item="surveyIndex + '-' + index"
                         v-if="!item.dependsOn || (typeof item.dependsOn !== 'undefined' && $data.content.cleanFormData[item.dependsOn.split(':')[0]] === item.dependsOn.split(':')[1])">

                            <h2 class="survey-heading text-center">{{ item.title }}</h2>
                            <div class="survey-description" v-if="item.description" v-html="item.description"></div>

                            <!-- Radio large -->
                            <div class="w-100" v-if="item.type == 'radio-large'">
                                <ul class="list-radio-large">
                                    <li v-for="(field, fieldIndex) in item.fields">
                                        <input :id="'radio-large-' + item.name + fieldIndex" type="radio" :name="item.name" :value="field.value" @change="handleChange()" @keypress.enter.prevent="enterHandler()" v-model="item.value" @focus="setActiveSurveyItem(surveyIndex, index, true, false)">
                                        <label :for="'radio-large-' + item.name + fieldIndex" style="display: inline-block" >
                                            <span class="list-title">{{ field.title }}</span>
                                            <span class="list-image-wrapper">
                                            <img src="../assets/person-127x127.png" style="pointer-events: none; position: relative;" v-if="field.value == 'Particulier'" :alt="field.title">
                                            <img src="../assets/building-127x127.png" style="pointer-events: none; position: relative;" v-if="field.value == 'Bedrijf'" :alt="field.title">
                                        </span>
                                        </label>
                                    </li>
                                </ul>
                            </div>

                            <!-- Radio -->
                            <div class="w-100" v-if="item.type == 'radio'">
                                <ul :class="'list-radio ' + (typeof item.center !== 'undefined' && item.center ? 'list-radio-center' : '')">
                                    <li v-for="(field, fieldIndex) in item.fields">
                                        <input :id="'radio-large-' + item.name + fieldIndex" type="radio" :name="item.name" :value="field.value" @keypress.enter.prevent="enterHandler()" @change="handleChange()" v-model="item.value" @focus="setActiveSurveyItem(surveyIndex, index, true, false)">
                                        <label :for="'radio-large-' + item.name + fieldIndex">
                                        <span class="list-image-wrapper">
                                            <img src="../assets/radio-2-image.png" v-if="field.title == 'Papier'" :alt="field.title">
                                            <img src="../assets/radio-4-image.png" v-if="field.title == 'Metaal'" :alt="field.title">
                                            <img src="../assets/radio-5-image.png" v-if="field.title == 'Aluminium'" :alt="field.title">
                                            <img src="../assets/radio-6-image.png" v-if="field.title == 'Materiaal'" :alt="field.title">
                                            <img src="../assets/radio-default.png" v-if="field.title != 'Papier' && field.title != 'Metaal' && field.title != 'Aluminium' && field.title != 'Materiaal'" :alt="field.title">
                                        </span>
                                            <span class="list-title">{{ field.title }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>

                            <!-- File -->
                            <div class="w-100" v-if="item.type == 'file'">
                                <b-form-file v-model="item.value" placeholder="" multiple @focus.native="setActiveSurveyItem(surveyIndex, index, true, false)" @change="handleChange()"></b-form-file>
                            </div>

                            <!-- Text / Select -->
                            <div v-for="field in item.fields">

                                <!-- Text -->
                                <div class="form-group" v-if="field.type == 'text'">
                                    <input class="form-control" v-model="field.value" type="text" :placeholder="field.placeholder" @focus="setActiveSurveyItem(surveyIndex, index, true, false)" @keypress.enter.prevent="enterHandler()" @keyup="checkFilledFields(surveyIndex, index)" required>
                                </div>

                                <!-- Select -->
                                <div class="form-group" v-if="field.type == 'select'" @keypress.enter.prevent="enterHandler()">
                                    <div class="fancy-select">
                                        <select class="form-control" v-model="field.value" :name="field.name" @change="handleChange()" @focus="setActiveSurveyItem(surveyIndex, index, true, false)">
                                            <option :value="option.value" v-for="option in field.options">{{ option.text }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <!-- Textarea -->
                            <div class="w-100" v-if="item.type == 'textarea'">
                                <textarea class="form-control" v-model="item.value" :name="item.name" :placeholder="item.placeholder" @focus="setActiveSurveyItem(surveyIndex, index, true, false)" @keyup="checkFilledFields(surveyIndex, index)"></textarea>
                            </div>

                        </div>
                    </div>
                    <div class="survey-item d-flex align-items-center justify-content-center flex-column active last-step">
                        <p style="max-width: 500px; text-align: center; margin-bottom: 40px;" v-html="content.sendText"></p>
                        <button class="btn btn-primary btn-lg" v-html="content.sendButtonText"></button>
                    </div>
                </form>
                <div class="form-sent-message" v-if="content.sent">
                    <b-alert show variant="success" v-html="content.confirmationText"></b-alert>
                </div>
                <a class="btn btn-back d-block" href="#" title="Terug" v-if="!content.sent && content.prevActive" @click="setPrevActiveItem()" v-html="content.backText"></a>
                <a class="btn btn-enter d-block" href="#" title="Enter" v-if="!content.sent && content.nextActive" @click="enterHandler()">
                    {{ content.enterText }}
                    <img class="icon" src="../assets/enter-icon.png" alt="Enter">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'hello',
        created () {
            var self = this
            this.$http.get('static/' + this.$route.params.type + '.json').then(response => {
                self.$data.content = Object.assign(self.$data.content, response.data)
                this.setCleanFields()
            }, response => {
                // error callback
            })
        },
        data () {
            return {
                content: {
                    isLoading: false,
                    sent: false,
                    prevActive: false,
                    nextActive: false,
                    currentSurveyStep: 1,
                    pre_title: '',
                    title: '',
                    sendText: '',
                    sendButtonText: '',
                    surveys: [],
                    backText: '',
                    enterText: '',
                    confirmationText: '',
                    cleanFormData: []
                }
            }
        },
        methods: {
            handleChange: function () {
                var self = this
                this.setCleanFields()
                self.setNextActiveItem()
            },
            setActiveSurveyItem: function (surveyIndex, index, isFocus = false, scrollTo = true) {
                var currentActive = this.getActiveSurveyItem()
                if (!(currentActive.survey === surveyIndex && currentActive.surveyItem === index)) {
                    this.removeActiveSurveyItem()
                    this.content.surveys[surveyIndex].steps[index].active = true
                    document.querySelectorAll('[data-survey-item="' + surveyIndex + '-' + index + '"]')[0].classList.add('active')

                    if (scrollTo) {
                        this.scrollToSurveyItem(surveyIndex, index)
                    }

                    this.content.title = this.content.surveys[surveyIndex].title
                    this.content.currentSurveyStep = surveyIndex + 1
                    if (typeof document.querySelectorAll('[data-survey-item="' + surveyIndex + '-' + index + '"]')[0].querySelectorAll('input')[0] !== 'undefined' && !isFocus) {
                        setTimeout(function () {
                            document.querySelectorAll('[data-survey-item="' + surveyIndex + '-' + index + '"]')[0].querySelectorAll('input')[0].focus()
                        }, 500)
                    } else if (typeof document.querySelectorAll('[data-survey-item="' + surveyIndex + '-' + index + '"]')[0].querySelectorAll('textarea')[0] !== 'undefined' && !isFocus) {
                        setTimeout(function () {
                            document.querySelectorAll('[data-survey-item="' + surveyIndex + '-' + index + '"]')[0].querySelectorAll('textarea')[0].focus()
                        }, 500)
                    }
                }

                if (index > 0 || (index === 0 && surveyIndex !== 0)) {
                    this.setPrevActive()
                } else {
                    this.setPrevInactive()
                }
            },
            getActiveSurveyItem: function () {
                var activeItem = {}
                for (var i = 0; i < this.content.surveys.length; i++) {
                    for (var a = 0; a < this.content.surveys[i].steps.length; a++) {
                        if (this.content.surveys[i].steps[a].active === true) {
                            activeItem.el = '[data-survey-item="' + i + '-' + a + '"]'
                            activeItem.survey = i
                            activeItem.surveyItem = a
                        }
                    }
                }
                return activeItem
            },
            removeActiveSurveyItem: function () {
                for (var i = 0; i < this.content.surveys.length; i++) {
                    for (var a = 0; a < this.content.surveys[i].steps.length; a++) {
                        this.content.surveys[i].steps[a].active = false
                        if (document.querySelectorAll('[data-survey-item="' + i + '-' + a + '"]').length > 0) {
                            document.querySelectorAll('[data-survey-item="' + i + '-' + a + '"]')[0].classList.remove('active')
                        }
                    }
                }
            },
            setNextActiveItem: function () {
                var self = this
                var activeItem = this.getActiveSurveyItem()
                var survey = null
                var surveyItem = null
                this.setNextInactive()

                // Last step
                if (((this.content.surveys.length - 1) === activeItem.survey) && (this.content.surveys[this.content.surveys.length - 1].steps.length - 1) === activeItem.surveyItem) {
                    this.removeActiveSurveyItem()
                    document.querySelectorAll('.survey-form')[0].scrollTop = (document.querySelectorAll('.last-step')[0].offsetTop - document.querySelectorAll('.survey-form')[0].offsetTop)
                } else {
                    activeItem.surveyItem = this.getNextSurveyItem(activeItem)
                    if (typeof this.content.surveys[activeItem.survey].steps[activeItem.surveyItem + 1] !== 'undefined') {
                        survey = activeItem.survey
                        surveyItem = activeItem.surveyItem + 1
                    } else if (typeof this.content.surveys[activeItem.survey + 1].steps[0] !== 'undefined') {
                        survey = activeItem.survey + 1
                        surveyItem = 0
                    } else {
                        survey = activeItem.survey
                        surveyItem = activeItem.surveyItem
                    }

                    setTimeout(function () {
                        self.setActiveSurveyItem(survey, surveyItem)
                    }, 100)
                }
            },
            setPrevActiveItem: function () {
                var self = this
                setTimeout(function () {
                    var activeItem = self.getActiveSurveyItem()
                    var survey = activeItem.survey
                    var surveyItem = activeItem.surveyItem

                    if (activeItem.surveyItem > 0) {
                        surveyItem = surveyItem - 1
                    } else if (activeItem.surveyItem === 0 && activeItem.survey > 0) {
                        survey = activeItem.survey - 1
                        surveyItem = self.content.surveys[survey].steps.length - 1
                    }

                    self.setActiveSurveyItem(survey, surveyItem)
                }, 200)
            },
            scrollToSurveyItem: function (surveyIndex, index) {
                setTimeout(function () {
                    document.querySelectorAll('.survey-form')[0].scrollTop = (document.querySelectorAll('[data-survey-item="' + surveyIndex + '-' + index + '"]')[0].offsetTop - document.querySelectorAll('.survey-form')[0].offsetTop)
                }, 100)
            },
            enterHandler: function () {
                var self = this
                setTimeout(function () {
                    self.setNextActiveItem()
                }, 300)
            },
            sendForm: function () {
                var self = this
                var data = new FormData()
                data.append('survey-type', this.$route.params.type)
                data.append('subject', this.content.title)
                data.append('pdfName', this.content.pdfName)
                data.append('mailTitle', this.content.mailTitle)
                data.append('meldingNaam', this.content.meldingNaam)
                if (typeof this.$route.params.site !== 'undefined') {
                    data.append('site', this.$route.params.site)
                }
                for (var i = 0; i < self.content.surveys.length; i++) {
                    for (var a = 0; a < self.content.surveys[i].steps.length; a++) {
                        var step = self.content.surveys[i].steps[a]
                        if (step.type === 'texts' || step.type === 'select') {
                            for (var b = 0; b < step.fields.length; b++) {
                                if (typeof step.fields[b].value === 'string' && step.fields[b].value.length > 0) {
                                    data.append(step.fields[b].name, step.fields[b].value)
                                }
                            }
                        } else if (step.type === 'file') {
                            for (var c = 0; c < step.value.length; c++) {
                                data.append(step.name + '-' + c, step.value[c])
                            }
                        } else {
                            if (typeof step.value === 'string' && step.value.length > 0) {
                                data.append(step.name, step.value)
                            }
                        }
                    }
                }
                this.content.isLoading = true
                this.$http.post('static/php/index.php', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    self.content.sent = true
                    self.content.isLoading = false
                }, response => {
                    self.content.sent = true
                    self.content.isLoading = false
                })
            },
            setPrevActive: function () {
                this.content.prevActive = true
            },
            setNextActive: function () {
                this.content.nextActive = true
            },
            setPrevInactive: function () {
                this.content.prevActive = false
            },
            setNextInactive: function () {
                this.content.nextActive = false
            },
            getNextSurveyItem: function (activeItem) {
                let thisItem = activeItem.surveyItem

                while (typeof this.content.surveys[activeItem.survey].steps[thisItem + 1] !== 'undefined' && typeof this.content.surveys[activeItem.survey].steps[thisItem + 1].dependsOn !== 'undefined' && !(this.$data.content.cleanFormData[this.content.surveys[activeItem.survey].steps[thisItem + 1].dependsOn.split(':')[0]] === this.content.surveys[activeItem.survey].steps[thisItem + 1].dependsOn.split(':')[1])) {
                    thisItem = thisItem + 1
                }

                return thisItem
            },
            scrollHandler: function (e) {
                var surveyItems = document.querySelectorAll('.survey-item')
                var currentItem = this.getActiveSurveyItem()
                for (var i = 0; i < surveyItems.length; i++) {
                    var surveyItem = surveyItems[i]
                    var itemOffset = surveyItem.offsetTop - document.querySelectorAll('.survey-form')[0].scrollTop

                    if (typeof surveyItem.dataset.surveyItem !== 'undefined') {
                        var surveyItemPosition = surveyItem.dataset.surveyItem.split('-')
                        if (itemOffset > -80 && itemOffset < 400 && (currentItem.survey !== parseInt(surveyItemPosition[0]) || currentItem.surveyItem !== parseInt(surveyItemPosition[1]))) {
                            this.setActiveSurveyItem(parseInt(surveyItemPosition[0]), parseInt(surveyItemPosition[1]), true, false)
                        }
                    }
                }
            },
            checkFilledFields: function (survey, surveyItem) {
                var el = document.querySelectorAll('[data-survey-item="' + survey + '-' + surveyItem + '"]')[0]
                var elInputs = el.querySelectorAll('input[type="text"], textarea')
                var nextActive = true

                for (var i = 0; i < elInputs.length; i++) {
                    if (elInputs[i].value.length < 1) {
                        nextActive = false
                    }
                }

                if (nextActive) {
                    this.setNextActive()
                }
            },
            setCleanFields: function () {
                var self = this
                var data = {}
                for (var i = 0; i < self.content.surveys.length; i++) {
                    for (var a = 0; a < self.content.surveys[i].steps.length; a++) {
                        var step = self.content.surveys[i].steps[a]
                        if (step.type === 'texts' || step.type === 'select') {
                            for (var b = 0; b < step.fields.length; b++) {
                                data[step.fields[b].name] = step.fields[b].value
                            }
                        } else {
                            data[step.name] = step.value
                        }
                    }
                }
                this.$data.content.cleanFormData = data
            }
        }
    }
</script>

<style scoped>

    /* Survey header */

    .survey-header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    @media only screen and (min-width: 768px) {

        .survey-header {
            margin-bottom: 70px;
        }
    }

    /* Survey */

    .survey {
        height: 55vh;
        overflow: auto;
        scroll-behavior: smooth;
    }

    .survey-item {
        padding-top: 40px;
        padding-bottom: 40px;
        padding-left: 20px;
        padding-right: 20px;
        transition: opacity 0.4s;
    }

    @media only screen and (min-width: 768px) {

        .survey-item {
            padding-top: 60px;
            padding-bottom: 60px;
            min-height: 55vh;
        }
    }

    .survey-item:not(.active):not(.scroll-active) {
        opacity: 0.1;
    }

    /* heading */

    .pre-heading {
        margin-bottom: 15px;
        color: #FFF;
        opacity: 0.5;
        font-weight: bold;
        font-size: 1.125rem;
    }

    h1 {
        margin-bottom: 0;
    }

    .survey-heading {
        margin-bottom: 20px;
        font-size: 1.625rem;
        color: #3B90BA;
        font-weight: 900;
    }

    @media only screen and (min-width: 768px) {

        .survey-heading {
            margin-bottom: 50px;
        }
    }

    .survey-description {
        text-align: center;
        max-width: 500px;
        margin: 0 auto 20px;
        font-size: 14px;
        color: #232323;
    }


    /* Large radio list */

    .list-radio-large {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        align-items: center;
    }

    .list-radio-large li {
        position: relative;
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .list-radio-large li label {
        transition: opacity 0.4s;
        box-sizing: border-box;
        opacity: 0.5;
    }

    .list-radio-large li :checked + label,
    .list-radio-large li label:hover {
        opacity: 1;
    }

    .list-radio-large li :checked + label .list-image-wrapper {
        border-color: #3B90BA;
        box-shadow: 0 1px 33px -1px rgba(0,0,0,0.15);
    }

    .list-radio-large input {
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .list-radio-large .list-title {
        display: block;
        text-align: center;
        color: #333;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .list-radio-large .list-image-wrapper {
        display: block;
        padding: 20px;
        background: #FFF;
        border: 4px solid #FFF;
        border-radius: 4px;
        transition: border 0.4s, box-shadow 0.4s;
        box-shadow: 0 1px 3px 1px rgba(0,0,0,0.08);
        text-align: center;
    }

    @media only screen and (max-width: 767px) {

        .list-radio-large .list-image-wrapper img {
            width: 50px;
            height: 50px;
        }

        .list-radio-large .list-title {
            font-size: 15px;
        }
    }

    @media only screen and (min-width: 768px) {

        .list-radio-large .list-image-wrapper {
            width: 260px;
            height: 220px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }


    /* Radio list */

    .list-radio {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        max-width: 630px;
        flex-wrap: wrap;
        margin: 0 auto;
    }

    .list-radio li {
        position: relative;
        width: 50%;
        padding-right: 20px;
    }

    .list-radio label {
        display: flex;
        align-items: center;
    }

    .list-radio input {
        position: absolute;
        opacity: 0;
    }

    .list-radio .list-image-wrapper {
        background: #FFF;
        box-shadow: 0 1px 3px 1px rgba(0,0,0,0.08);
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 4px solid #FFF;
        transition: border 0.4s, box-shadow 0.4s;
    }

    .list-radio .list-title {
        font-weight: 700;
        margin-left: 20px;
        word-break: break-word;
    }

    .list-radio label {
        transition: opacity 0.4s;
        opacity: 0.5;
    }

    .list-radio :checked + label,
    .list-radio label:hover {
        opacity: 1;
    }

    .list-radio :checked + label .list-image-wrapper {
        border-color: #E0555B;
        box-shadow: 0 1px 33px -1px rgba(0,0,0,0.15);
    }

    @media only screen and (max-width: 767px) {

        .list-radio .list-image-wrapper {
            padding: 5px;
        }


        .list-radio .list-image-wrapper img {
            width: 20px;
            height: 20px;
        }
    }

    @media only screen and (min-width: 768px) {

        .list-radio li {
            width: 50%;
            margin-bottom: 20px;
        }

        .list-radio .list-image-wrapper {
            width: 64px;
            height: 64px;
            border-radius: 4px;
        }

        .list-radio .list-title {
            font-size: 22px;
            margin-left: 30px;
        }
    }

    .list-radio-center {
        justify-content: center;
    }

    .list-radio-center li {
        width: auto;
        padding-right: 40px;
    }



    /* survey-count */

    .survey-count {
        line-height: 1;
        margin-bottom: 0;
        color: #FFF;
        font-weight: bold;
        font-size: 22px;
        letter-spacing: 5px;
        margin-left: 20px;
    }

    .survey-count-total {
        opacity: 0.5;
        font-size: 18px;
    }

    @media only screen and (min-width: 768px) {

        .survey-count {
            font-size: 49px;
            margin-bottom: -10px;
        }

        .survey-count-total {
            font-size: 36px;
        }
    }


    /* Back / enter btn */

    .btn-back,
    .btn-enter {
        position: absolute;
        bottom: 10px;
        font-size: 14px;
        color: #000;
        letter-spacing: 0.3px;
        text-align: center;
        background-color: #FFF;
        padding: 13px 15px;
        text-transform: uppercase;
        font-weight: bold;
        opacity: 0.5;
        box-shadow: 0 1px 3px 0 rgba(0,0,0,0.10);
        transition: all 0.4s;
    }

    .btn-enter,
    .btn-back:hover {
        opacity: 1;
    }

    .btn-enter:hover {
        box-shadow: 0 1px 4px 0 rgba(0,0,0,0.20);
    }

    .btn-enter .icon {
        display: inline-block;
        vertical-align: middle;
        margin: -4px 0 0 5px;
    }

    .btn-back {
        left: 10px;
    }

    .btn-enter {
        right: 10px;
    }

    @media only screen and (min-width: 768px) {

        .btn-back {
            bottom: 40px;
            left: 40px;
        }

        .btn-enter {
            bottom: 40px;
            right: 40px;
        }
    }


    /* Form sent message */

    .form-sent-message {
        padding: 20px;
    }

    .alert-success {
        margin-bottom: 0;
    }

    /* Last step */

    .last-step {
        height: 55vh;
    }


    /* Loading indicator */

    .loading-indicator {
        position: absolute;
        display: block;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.8);
        z-index: 200;
        border-radius: 3px;
    }

    .loading-indicator img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }


    /* Textarea */

    textarea {
        max-width: 500px;
        margin: 0 auto;
        height: 150px;
        padding-top: 30px;
        padding-bottom: 30px;
    }


    /* File input */

    .custom-file-label {
        border-radius: 4px;
        box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.16) !important;
    }

    .custom-file {
        max-width: 500px;
        margin: 0 auto;
        display: block;
        cursor: pointer;
    }

    .custom-file input,
    .custom-file-label {
        cursor: pointer;
    }

    @media screen and (max-width: 767px) {

        .survey-heading {
            font-size: 18px;
        }

        .form-control {
            font-size: 12px;
        }

        .list-radio li {
            width: 100%;
            padding-right: 0;
        }

        .list-radio-large li {
            padding-left: 10px;
            padding-right: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Survey.vue